<script setup lang="ts">
import iconHeading from "@/assets/images/ranking/icon_heading_point.svg";
import point01Sp from "@/assets/images/ranking/point01_sp.png";
import point01Pc from "@/assets/images/ranking/point01_pc.png";
import point02 from "@/assets/images/ranking/point02.png";
import point03 from "@/assets/images/ranking/point03.png";
import worriesSp from "@/assets/images/ranking/worries_sp.png";
import worriesPc from "@/assets/images/ranking/worries_pc.png";
import ribbonPoints from "@/assets/images/ranking/ribbon_points.png";
import partInduction from "@/assets/images/ranking/part_induction.svg";
import consultantIllust from "@/assets/images/ranking/consultant_illust.png";
import merit01 from "@/assets/images/ranking/merit01.png";
import merit02 from "@/assets/images/ranking/merit02.png";
import merit03 from "@/assets/images/ranking/merit03.png";

const points = [
  {
    no: 1,
    label: "Point.01",
    imgSp: point01Sp,
    imgPc: point01Pc,
    title: "住宅の構造・耐火耐震",
    desc: "戸建てやマンションなど構造の違い（木造・鉄骨・RC造）で火災リスクが異なり、耐震等級によって地震保険の保険料にも影響します。",
  },
  {
    no: 2,
    label: "Point.02",
    img: point02,
    title: "築年数",
    desc: "築年数によって建物の評価額や補償金額の考え方が異なります。古い物件ほど確認が重要です。",
  },
  {
    no: 3,
    label: "Point.03",
    img: point03,
    title: "住んでいる地域",
    desc: "河川・海岸沿いなど水害リスクの高い地域や、地震リスクの高い地域では補償の優先度が変わります。",
  },
];

const merits = [
  {
    img: merit01,
    titleSp: ["あなたの家に合わせてご提案"],
    titlePc: ["あなたの家に合わせてご提案"],
    descSp: ["専門の代理店担当者が", "あなたの住宅条件に合わせて個別にご提案！"],
    descPc: ["専門の代理店担当者があなたの住宅条件に合わせて個別にご提案！"],
  },
  {
    img: merit02,
    titleSp: ["複数社を比較できる"],
    titlePc: ["複数社を比較できる"],
    descSp: ["最大15社・41商品をまとめて比較。", "自分に合った保険が見つかります！"],
    descPc: ["最大15社・41商品をまとめて比較。自分に合った保険が見つかります！"],
  },
  {
    img: merit03,
    titleSp: ["見積もり・相談すべて無料"],
    titlePc: ["見積もり・相談", "すべて無料"],
    descSp: ["費用は一切かかりません。", "強引な勧誘も一切なし！"],
    descPc: ["費用は一切かかりません。", "強引な勧誘も一切なし！"],
  },
];
</script>

<template>
  <section class="howto">
    <AtomsRankingHeading
      :icon="iconHeading"
      title="あなたにあった火災保険の選び方"
    />
    <p class="howto-lead">
      住宅の種類・築年数・地域・補償内容によって最適な保険は異なります。
    </p>

    <!-- 選び方の3つのポイント -->
    <div class="howto-pointsWrap">
      <img :src="ribbonPoints" alt="選び方の3つのポイント！" class="ribbon" />
      <div class="points">
        <div v-for="point in points" :key="point.label" class="pointCard">
          <span class="pointCard-label">{{ point.label }}</span>
          <span class="pointCard-imgWrap">
            <template v-if="point.img">
              <img :src="point.img" alt="" :class="['pointCard-img', `pointCard-img--${point.no}`]" />
            </template>
            <template v-else>
              <img :src="point.imgSp" alt="" :class="['pointCard-img', `pointCard-img--${point.no}`, 'deviceisMobile']" />
              <img :src="point.imgPc" alt="" :class="['pointCard-img', `pointCard-img--${point.no}`, 'deviceisDesktop']" />
            </template>
          </span>
          <h3 class="pointCard-title">{{ point.title }}</h3>
          <p class="pointCard-desc">{{ point.desc }}</p>
        </div>
      </div>
    </div>

    <!-- 悩み -->
    <div class="worries">
      <img :src="worriesSp" alt="" class="worries-img deviceisMobile" />
      <img :src="worriesPc" alt="" class="worries-img deviceisDesktop" />
    </div>

    <!-- つなぎ -->
    <img :src="partInduction" alt="" class="howto-induction" />

    <!-- 解決策 -->
    <div class="solution">
      <div class="solution-lead">
        <p class="solution-leadText">
          <span class="solution-leadText-1"
            >まずは<b>プロに無料で相談</b>してみませんか？</span
          >
          <span class="solution-leadText-2"
            ><b>保険スクエアbang!</b> なら</span
          >
        </p>
        <img :src="consultantIllust" alt="" class="solution-illust" />
      </div>
      <div class="merits">
        <div v-for="(merit, idx) in merits" :key="idx" class="meritCard">
          <span class="meritCard-imgWrap">
            <img :src="merit.img" alt="" class="meritCard-img" />
          </span>
          <h3 class="meritCard-title deviceisMobile">
            <template v-for="(line, i) in merit.titleSp" :key="i"
              >{{ line }}<br v-if="i < merit.titleSp.length - 1"
            /></template>
          </h3>
          <h3 class="meritCard-title deviceisDesktop">
            <template v-for="(line, i) in merit.titlePc" :key="i"
              >{{ line }}<br v-if="i < merit.titlePc.length - 1"
            /></template>
          </h3>
          <p class="meritCard-desc deviceisMobile">
            <template v-for="(line, i) in merit.descSp" :key="i"
              >{{ line }}<br v-if="i < merit.descSp.length - 1"
            /></template>
          </p>
          <p class="meritCard-desc deviceisDesktop">
            <template v-for="(line, i) in merit.descPc" :key="i"
              >{{ line }}<br v-if="i < merit.descPc.length - 1"
            /></template>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.howto-lead {
  padding: 15px 15px 27px;
  font-size: px(13);
  line-height: 1.5;
  color: $colorBasicText;
}

/* リボン見出し */
.howto-pointsWrap {
  position: relative;
  padding: 0 15px;
}

.ribbon {
  display: block;
  position: relative;
  z-index: 1;
  margin: 0 auto -28px;
  width: 327px;
  max-width: 100%;
  height: auto;
}

/* ポイント3枚 */
.points {
  padding: 32px 15px 24px;
  background-color: #9ed8ff;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pointCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px 24px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
}

.pointCard-label {
  padding: 1px 12px;
  border: 1px solid $colorBlue;
  border-radius: 30px;
  font-size: px(12);
  font-weight: 700;
  color: $colorBlue;
  text-transform: uppercase;
}

.pointCard-imgWrap {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.pointCard-img {
  height: auto;
  width: auto;
}

.pointCard-img--1 {
  margin-top: 12px;
  width: 202px;
}

.pointCard-img--2 {
  margin-top: 7px;
  width: 96px;
}

.pointCard-img--3 {
  width: 93px;
}

.pointCard-title {
  margin-top: 12px;
  font-size: px(15);
  font-weight: 700;
  color: $colorBlue;
  text-align: center;
}

.pointCard-desc {
  margin-top: 8px;
  font-size: px(13);
  line-height: 1.5;
  color: $colorBasicText;
}

/* 悩み */
.worries-img {
  width: 100%;
  height: auto;
}

/* つなぎ */
.howto-induction {
  margin: 8px auto 10px;
  display: block;
  width: 200px;
  height: auto;
}

/* 解決策 */
.solution {
  margin: 0 0 40px;
  padding: 24px 15px;
  background-color: #fff7f0;
}

.solution-lead {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.solution-leadText {
  text-align: center;

  b {
    color: $colorOrange;
    font-weight: 700;
  }
}

.solution-leadText-1 {
  display: block;
  font-size: px(15);
}

.solution-leadText-2 {
  display: block;
  font-size: px(22);
  font-weight: 700;
}

.solution-illust {
  width: 280px;
  max-width: 100%;
  height: auto;
}

.merits {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.meritCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 25px 17px;
  border: 1px solid #ffcca3;
  border-radius: 8px;
  background-color: #fff;
}

.meritCard-imgWrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 112px;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 184px;
    height: 48px;
    border-radius: 50%;
    background-color: #ffdcc0;
    z-index: 0;
  }
}

.meritCard-img {
  position: relative;
  z-index: 1;
  height: 112px;
  width: auto;
}

.meritCard-title {
  font-size: px(15);
  font-weight: 700;
  line-height: 1.25;
  color: $colorOrange;
  text-align: center;
}

.meritCard-desc {
  font-size: px(13);
  line-height: 1.5;
  color: $colorBasicText;
  text-align: center;
}

@include media(pc) {
  .howto-lead {
    padding: 15px 0;
    font-size: px(15);
  }

  .howto-pointsWrap {
    padding: 0;
  }

  .ribbon {
    width: 327px;
    margin: 0 auto -21px;
  }

  /* ポイント: PC横3列 */
  .points {
    flex-direction: row;
    justify-content: space-between;
    padding: 32px 24px 24px;
    gap: 8px;
  }

  .pointCard {
    padding: 16px 16px 27px;
    flex: 1;
    box-sizing: border-box;
  }

  .pointCard-img--1 {
    margin-top: 10px;
    width: 155px;
  }

  .pointCard-img--2 {
    margin-top: 10px;
    width: 117px;
  }

  .pointCard-img--3 {
    margin-top: 10px;
    width: 120px;
  }

  .pointCard-desc {
    margin-top: 11px;
  }

  .howto-induction {
    margin: 3px auto 0;
    width: 240px;
  }

  /* 解決策: PC */
  .solution {
    margin: 0 0 56px;
    padding: 24px;
  }

  .solution-lead {
    position: relative;
    padding-left: 63px;
    align-items: flex-start;
  }

  .solution-illust {
    position: absolute;
    bottom: 0;
    right: 32px;
    width: 188px;
    height: 112px;
    max-width: none;
  }

  .merits {
    flex-direction: row;
    gap: 8px;
  }

  .meritCard {
    padding: 24px 16px 24px;
    flex: 1;
    box-sizing: border-box;
  }

  .meritCard-imgWrap {
    height: 80px;

    &::after {
      width: 131px;
      height: 34px;
    }
  }

  .meritCard-img {
    height: 80px;
  }

  .meritCard-desc {
    text-align: left;
  }
  .meritCard-title {
    &.deviceisDesktop {
      height: 3em;
      display: flex;
      align-items: center;
    }
  }
}
</style>
